// extracted by mini-css-extract-plugin
export default {"container":"ObligeeRegistryDetails_container__nhpCf","goBackBtn":"ObligeeRegistryDetails_goBackBtn__ZVnPM"};